import { Routes } from '@angular/router';
import { MainComponent } from '@app/modules/application/pages/main/main.component';
import { BookingLocalModule } from '@modules/booking/booking-local.module';
import { ModuleAvailableGuard } from '@modules/application/guards/module-available.guard';
import { DocumentsLocalModule } from '@modules/documents/documents-local.module';
import { VirtualIdLocalModule } from '@modules/virtual-id/virtual-id-local.module';
import { ModulesResolve } from '@modules/application/guards/modules.resolve';
import { InscriptionLocalModule } from '@modules/academy/academy-local.module';
import { RecurringPaymentLocalModule } from '@modules/recurring-payments/recurring-payments-local.module';
import { MemberInformationLocalModule } from '@modules/member-information-update/member-information-update-local.module';
import { MemberStateLocalModule } from '@modules/member-state/member-state-local.module';
import { PollLocalModule } from '@modules/polling/polling-local.module';
import { AccountSettingsLocalModule } from '@modules/account-settings/account-settings-local.module';
const ɵ0 = () => import("./../dashboard/dashboard.module.ngfactory").then((m) => m.DashboardModuleNgFactory), ɵ1 = () => import("./../payment/payment.module.ngfactory").then((m) => m.PaymentModuleNgFactory), ɵ2 = () => import("./../meeting/meeting.module.ngfactory").then((m) => m.MeetingModuleNgFactory), ɵ3 = () => import("./../account-settings/account-settings.module.ngfactory").then((m) => m.AccountSettingsModuleNgFactory), ɵ4 = {
    identifier: AccountSettingsLocalModule.code,
}, ɵ5 = () => import("./../polling/polling.module.ngfactory").then((m) => m.PollingModuleNgFactory), ɵ6 = {
    identifier: PollLocalModule.code,
}, ɵ7 = () => import("./../member-state/member-state.module.ngfactory").then((m) => m.MemberStateModuleNgFactory), ɵ8 = {
    identifier: MemberStateLocalModule.code,
}, ɵ9 = () => import("./../member-information-update/member-information-update.module.ngfactory").then((m) => m.MemberInformationUpdateModuleNgFactory), ɵ10 = {
    identifier: MemberInformationLocalModule.code,
}, ɵ11 = () => import("./../recurring-payments/recurring-payments.module.ngfactory").then((m) => m.RecurringPaymentsModuleNgFactory), ɵ12 = {
    identifier: RecurringPaymentLocalModule.code,
}, ɵ13 = () => import("./../booking/booking.module.ngfactory").then((m) => m.BookingModuleNgFactory), ɵ14 = {
    identifier: BookingLocalModule.code,
}, ɵ15 = () => import("./../academy/academy.module.ngfactory").then((m) => m.AcademyModuleNgFactory), ɵ16 = {
    identifier: InscriptionLocalModule.code,
}, ɵ17 = () => import("./../virtual-id/virtual-id.module.ngfactory").then((m) => m.VirtualIdModuleNgFactory), ɵ18 = {
    identifier: VirtualIdLocalModule.code,
}, ɵ19 = () => import("./../documents/documents.module.ngfactory").then((m) => m.DocumentsModuleNgFactory), ɵ20 = {
    identifier: DocumentsLocalModule.code,
};
const routes = [
    {
        path: '',
        component: MainComponent,
        resolve: {
            modules: ModulesResolve,
        },
        children: [
            {
                path: '',
                loadChildren: ɵ0,
            },
            // {
            //     path: 'search',
            //     component: SearchPageComponent,
            // },
            // {
            //     path: 'user/:user',
            //     component: ProfilePageComponent,
            // },
            // {
            //     path: 'user',
            //     redirectTo: '',
            // },
            // {
            //     path: 'profile/setting',
            //     loadChildren: () =>
            //         import('@app/modules/web-profile/web-profile.module').then((m) => m.WebProfileModule),
            // },
            {
                path: 'payment',
                loadChildren: ɵ1,
            },
            {
                path: 'events',
                loadChildren: ɵ2,
            },
            {
                path: 'account-settings',
                loadChildren: ɵ3,
                data: ɵ4,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'polling',
                loadChildren: ɵ5,
                data: ɵ6,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'state',
                loadChildren: ɵ7,
                data: ɵ8,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'member-information',
                loadChildren: ɵ9,
                data: ɵ10,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'recurring-payments',
                loadChildren: ɵ11,
                data: ɵ12,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'booking',
                loadChildren: ɵ13,
                data: ɵ14,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'inscription',
                loadChildren: ɵ15,
                data: ɵ16,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'virtual-id',
                loadChildren: ɵ17,
                data: ɵ18,
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'documents',
                loadChildren: ɵ19,
                data: ɵ20,
                canActivate: [ModuleAvailableGuard],
            },
        ],
    },
];
export const ApplicationRoutes = routes;
export class ApplicationRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20 };
